import { NavLink, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchPlatformLogout } from "../../../store/authSlice";
import L from "../../../constants/baysportLabels";
import { Avatar } from "../../ui";
import { IconLogout } from "../../ui/icons";
import { useIsMobile } from "../../../hooks/useMediaQuery";
import {
  PLATFORM_MORE_LINKS,
  platformNavIcon,
} from "../../../utils/platformNav";
import s from "./platformAdmin.module.css";

export default function PlatformMore() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile(900);
  const { profile } = useSelector((state) => state.auth);

  if (!isMobile) {
    return <Navigate to="/admin" replace />;
  }

  const logout = () => {
    dispatch(fetchPlatformLogout());
    navigate("/admin");
  };

  return (
    <div className={s.appMorePage}>
      <header className={s.appMoreHead}>
        <h1 className={s.appMoreTitle}>Ещё</h1>
      </header>

      <div className={s.appMoreProfile}>
        <Avatar name={profile?.full_name || profile?.email || "A"} size="md" />
        <div className={s.appMoreProfileInfo}>
          <p className={s.appMoreProfileName}>
            {profile?.full_name || "Админ платформы"}
          </p>
          <p className={s.appMoreProfileRole}>
            {profile?.email || L.productName}
          </p>
        </div>
      </div>

      <section className={s.appMoreGroup}>
        <h2 className={s.appMoreGroupTitle}>Разделы</h2>
        <div className={s.appMoreList}>
          {PLATFORM_MORE_LINKS.map((item) => {
            const Icon = platformNavIcon(item.icon);
            return (
              <NavLink
                key={item.id}
                to={item.to}
                className={({ isActive }) =>
                  isActive
                    ? `${s.appMoreItem} ${s.appMoreItemActive}`
                    : s.appMoreItem
                }
              >
                <span className={s.appMoreItemIcon}>
                  <Icon />
                </span>
                <span className={s.appMoreItemLabel}>{item.label}</span>
                <span className={s.appMoreItemChevron} aria-hidden />
              </NavLink>
            );
          })}
        </div>
      </section>

      <section className={s.appMoreGroup}>
        <div className={s.appMoreList}>
          <a href="/" className={s.appMoreItem}>
            <span className={s.appMoreItemLabel}>На сайт {L.productName}</span>
            <span className={s.appMoreItemChevron} aria-hidden />
          </a>
          <button type="button" className={s.appMoreItem} onClick={logout}>
            <span className={s.appMoreItemIcon}>
              <IconLogout />
            </span>
            <span className={s.appMoreItemLabel}>Выйти</span>
          </button>
        </div>
      </section>
    </div>
  );
}
